import { render } from "./GuideTabList.vue?vue&type=template&id=48350a86&scoped=true&ts=true"
import script from "./GuideTabList.vue?vue&type=script&lang=ts"
export * from "./GuideTabList.vue?vue&type=script&lang=ts"

import "./GuideTabList.vue?vue&type=style&index=0&id=48350a86&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/hems-frontend-vue_au_v1.33.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48350a86"]])

export default __exports__